import { useEffect } from 'react'
import { create } from 'zustand'

/**
 * What a page puts in the header bar: its own title and a line under it, in place of
 * the module's name, and a slot on the right for things that live there (the till's
 * connection and clock). Most pages set nothing and keep the module's name.
 */
type PageHeaderState = {
  title?: string
  subtitle?: string
  /** The element the header keeps for a page's own controls, once it is on screen. */
  slot: HTMLElement | null
  set: (header: { title?: string; subtitle?: string }) => void
  setSlot: (slot: HTMLElement | null) => void
}

export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  slot: null,
  set: (header) => set({ title: header.title, subtitle: header.subtitle }),
  setSlot: (slot) => set({ slot }),
}))

/** Sets the header's title and subtitle while the calling page is on screen. */
export function usePageHeader(title: string, subtitle?: string) {
  const set = usePageHeaderStore((s) => s.set)
  useEffect(() => {
    set({ title, subtitle })
    return () => set({})
  }, [set, title, subtitle])
}
